import { render, staticRenderFns } from "./alarmResetting.vue?vue&type=template&id=2daae5ac&"
import script from "./alarmResetting.vue?vue&type=script&lang=js&"
export * from "./alarmResetting.vue?vue&type=script&lang=js&"
import style0 from "./alarmResetting.vue?vue&type=style&index=0&id=2daae5ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports